import {withLocalization} from '@epic-core/localization';
import classNames from 'classnames';
import {connectToStores} from 'epic-alt-utils';
import AppConfigStore from 'epic-fortnite-react/stores/AppConfigStore';
import FooterStore from 'epic-fortnite-react/stores/FooterStore';
import HeaderStore from 'epic-fortnite-react/stores/HeaderStore';
import MobileStore from 'epic-fortnite-react/stores/MobileStore';
import {generateRouteHref} from 'epic-fortnite-react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import Helmet from 'react-helmet';
import root from 'window-or-global';

import ClientDownload from '../../components/download/ClientDownload';
import FriendInviteStore from '../../stores/FriendInviteStore';

/**
 * DownloadView.
 *
 * Rendered when the Route matches /download
 */
@connectToStores
class DownloadView extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    messages: PropTypes.object,
    appConfigStore: PropTypes.object,
    mobileStore: PropTypes.object,
    friendInviteStore: PropTypes.object,
    footerStore: PropTypes.object,
    fnMobile: PropTypes.bool,
    mobile: PropTypes.bool,
    callToActionDropdown: PropTypes.object,
  };

  static getStores() {
    return [AppConfigStore, MobileStore, FriendInviteStore, HeaderStore];
  }

  static getPropsFromStores() {
    return {
      appConfigStore: AppConfigStore.getState(),
      friendInviteStore: FriendInviteStore.getState(),
      mobileStore: MobileStore.getState(),
      footerStore: FooterStore.getState(),
      mobile: HeaderStore.getState().mobile(),
      callToActionDropdown: HeaderStore.getState().config.callToActionDropdown,
    };
  }

  componentDidMount() {
    if (root._epicGamesNav.browser.windows && !this.props.fnMobile) {
      setTimeout(() => {
        root.location = this.props.appConfigStore.pcDownloadUrl;
      }, 2000);
    }
  }

  render() {
    // set noindex tag if user is hitting /success
    const meta = [];
    const {location} = this.props;

    if (location.pathname.indexOf('success') >= 0) {
      meta.push({name: 'robots', content: 'noindex'});
    }
    const {friend} = queryString.parse(location.search);
    const {messages, friendInviteStore, mobileStore} = this.props;
    const mobileData = mobileStore.mobileData.codeConfirm;
    const iosLink = this.props.mobile ? mobileData.mobileLink : mobileData.appLink;
    const legalTags = this.props.footerStore.config.legalTags || [];
    const callToActionDropdownLinks = this.props.callToActionDropdown.links || [];
    const disableAndroid =
      mobileStore.androidMobileData.hideDownload && mobileStore.androidMobileData.createAccount;
    let supportedDevices = ['windows', 'android'];
    if (disableAndroid) {
      supportedDevices = ['windows'];
    }
    const containerClass = classNames('downloadView', {fnMobile: this.props.fnMobile});

    // altPlaftformLinks returns hrefTemplate from link matching "key" argument

    const altPlatformLinks = (key) => {
      let platformLink = '';
      callToActionDropdownLinks?.forEach((link) => {
        if (link.key === key) {
          platformLink = link.hrefTemplate;
        }
      });
      return platformLink;
    };

    return (
      <div className={`${containerClass} theEnd-background-override theEnd-all-children-override`}>
        <Helmet meta={meta} />
        <ClientDownload
          supportedOS={supportedDevices}
          className="site-block"
          headerMsg={messages['epic.fortnite.download.header']}
          mobileHeaderMsg={mobileData.title}
          iOSDownloadUnavailable={messages['epic.fortnite.download.unavailable']}
          bodyMsg={messages['epic.fortnite.download.body']}
          selectMsg={messages['epic.fortnite.download.select']}
          pcDownloadUrl={this.props.appConfigStore.pcDownloadUrl}
          macDownloadUrl={this.props.appConfigStore.macDownloadUrl}
          iosDownloadUrl={iosLink}
          xboxMsg={messages['epic.common.xbl']}
          xboxLink={altPlatformLinks('xcloud')}
          gfnLink={altPlatformLinks('gfn')}
          androidUrl={generateRouteHref('/mobile/android', location)}
          returnHomeMsg={messages['epic.fortnite.download.return']}
          mobileMsg={messages['epic.fortnite.download.mobile']}
          chooseAltPlatformMsg={messages['epic.fortnite.download.chooseanother']}
          windowMsg={messages['epic.common.windows']}
          macMsg={messages['epic.common.mac']}
          iosMsg={messages['epic.common.ios']}
          androidMsg={messages['epic.common.android']}
          legalTags={legalTags}>
          {friend ? (
            <div>
              <h1>{friendInviteStore.friendInvite.data.successTitle}</h1>
              <h3>{friendInviteStore.friendInvite.data.successCopy}</h3>
              <h2>{friendInviteStore.friendInvite.data.successDownload}</h2>
            </div>
          ) : null}
        </ClientDownload>
      </div>
    );
  }
}

export default withLocalization(DownloadView);
